import MediaViewer from './MediaViewer';

export default MediaViewer;